import { siteConfig } from "@/config/site";

interface LogoProps {
  className?: string;
  /** Show only icon, no text */
  iconOnly?: boolean;
}

export function Logo({ className = "", iconOnly = false }: LogoProps) {
  const brand = siteConfig.brandName;
  const logo = siteConfig.theme.logo;

  return (
    <div className={`flex items-center gap-[8px] ${className}`}>
      <div className="size-[32px] shrink-0 relative">
        <svg
          aria-label={brand}
          className="block size-full"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
        >
          <path d="M23 15C23 13.3431 24.3431 12 26 12C27.6569 12 29 13.3431 29 15V17C29 18.6569 27.6569 20 26 20C24.3431 20 23 18.6569 23 17V15Z" fill={logo.shortBar} />
          <path d="M15 10C15 8.34315 16.3431 7 18 7C19.6569 7 21 8.34315 21 10V22C21 23.6569 19.6569 25 18 25C16.3431 25 15 23.6569 15 22V10Z" fill={logo.mediumBar} />
          <path d="M7 5C7 3.34315 8.34315 2 10 2C11.6569 2 13 3.34315 13 5V27C13 28.6569 11.6569 30 10 30C8.34315 30 7 28.6569 7 27V5Z" fill={logo.tallBar} />
          <path d="M0 12C0 10.3431 1.34315 9 3 9C4.65685 9 6 10.3431 6 12V20C6 21.6569 4.65685 23 3 23C1.34315 23 0 21.6569 0 20V12Z" fill={logo.baseBar} />
          <path d="M26 1C26 3.76142 28.2386 6 31 6C28.2386 6 26 8.23858 26 11C26 8.23858 23.7614 6 21 6C23.7614 6 26 3.76142 26 1Z" fill={logo.sparkle} />
        </svg>
      </div>
      {!iconOnly && (
        <div className="flex items-center justify-center pb-[8px] pt-[7px] shrink-0">
          <span
            className="[font-family:var(--font-commissioner)] font-bold not-italic text-[24px] leading-[32px] text-text tracking-[-0.48px] whitespace-nowrap"
            style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
          >
            {brand}
          </span>
        </div>
      )}
    </div>
  );
}
